<template>
  <div class="card">
    <div class="card-header">
      <valuation-header
        :refNo="valuation.val_ref_num"
        :valuation="valuation"
        page="Drafts"
        @valuationUpdated="valuation = $event"
      ></valuation-header>
    </div>
    <div class="card-body">
      <rv-wizard></rv-wizard>
      <div class="row" style="margin-bottom: 30px">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-icon btn-border"
            style="margin-right: 5px"
            title="Toggle priority"
            @click="markAsPriority"
            :disabled="
              valuation.isLocked == true || valuation.status == 'cancel'
            "
          >
            <i class="fa fa-space-shuttle" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            class="btn btn-icon btn-border"
            style="margin-right: 5px"
            title="Lock valuation"
            @click="lockValuation"
            v-if="
              !valuation.isLocked &&
              roleInfo == 'supervisor' &&
              valuation.status != 'cancel'
            "
          >
            <i class="fa fa-lock" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="btn btn-icon btn-border"
            style="margin-right: 5px"
            @click="lockValuation"
            title="Unlock valuation"
            v-if="valuation.isLocked && roleInfo == 'supervisor'"
          >
            <i class="fa fa-unlock-alt" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="btn btn-icon btn-border"
            style="margin-right: 5px"
            disabled
            title="Generate invoice"
          >
            <i class="fa fa-dollar" aria-hidden="true"></i>
          </button>

          <button
            @click.prevent="navigateTo('valuation-history')"
            class="btn btn-icon btn-border"
            title="Valuation History"
          >
            <i class="fa fa-history" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Report Template</label>
            <select class="form-control custom-select" v-model="template">
              <option value>-Select-</option>
              <option
                v-for="(item, index) in templates"
                :value="item.id"
                :key="index"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">&nbsp;</label>
          <button
            type="button"
            class="btn btn-primary"
            @click="generateReport"
            :disabled="
              valuation.isLocked == true || valuation.status == 'cancel'
            "
          >
            Generate Report
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <hr />
        </div>
      </div>
      <div v-for="(item, index) in valuation.filtered_report" :key="index">
        <div class="row">
          <div class="col-md-6 align-middle">
            <label class="align-middle" style="font-weight: bold">
              Template:
            </label>
            {{ item.name }}
          </div>
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-icon btn-border pull-right"
              title="Upload manually updated report"
              @click="manualReport(item)"
            >
              <i class="fa fa-cloud-upload" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 table-responsive">
            <table class="table table-striped table-sm text-nowrap">
              <thead>
                <tr>
                  <th scope="col" class="text-center">Date</th>
                  <th scope="col">Report Name</th>
                  <th scope="col" class="text-center">Signed Date</th>
                  <th scope="col" class="text-center">Send Date</th>
                  <th scope="col">Creator</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-if="item != null"
                  v-for="(item, index) in item.reports"
                  :key="index"
                  class="align-middle"
                >
                  <td class="text-center align-middle">
                    {{ item.created_at | formatDate }}
                  </td>
                  <td class="align-middle">
                    <a
                      :href="rootUrl + 'serve-file?link=' + item.raw_report_url"
                      target="_blank"
                      :title="`Download ${item.report_name}`"
                      class="d-inline-block text-truncate align-middle"
                      style="max-width: 35em"
                    >
                      {{ item.report_name }}
                    </a>
                    <i
                      v-if="item.sign_dt !== null && item.sign_dt !== ''"
                      class="fa fa-check"
                      aria-hidden="true"
                      title="Signed"
                      style="margin-left: 5px"
                    ></i>
                    <i
                      v-if="item.send_dt !== null && item.send_dt !== ''"
                      class="fa fa-send"
                      title="Sent"
                      aria-hidden="true"
                      style="margin-left: 5px"
                    ></i>
                  </td>
                  <td class="text-center align-middle">
                    <span v-if="item.sign_dt !== null && item.sign_dt !== ''">
                      {{ item.sign_dt | formatDate }}
                    </span>
                    <span v-else>---</span>
                  </td>

                  <td class="text-center align-middle">
                    <span v-if="item.send_dt !== null && item.send_dt !== ''">
                      {{ item.send_dt | formatDate }}
                    </span>
                    <span v-else>---</span>
                  </td>

                  <td class="align-middle">
                    <span v-if="item.user != null">{{ item.user.name }}</span>
                  </td>
                  <td class="align-middle">
                    <button
                      type="button"
                      class="btn btn-icon btn-border"
                      title="Alert"
                      @click="openAlert(item)"
                      v-b-modal.alert-draft
                      :disabled="
                        valuation.isLocked == true ||
                        valuation.status == 'cancel'
                      "
                    >
                      <i class="fa fa-bell" aria-hidden="true"></i>
                    </button>

                    <button
                      type="button"
                      class="btn btn-icon btn-border"
                      title="Sign"
                      @click="openSign(item)"
                      v-b-modal.sign
                      v-if="
                        item.status != 'sign' &&
                        item.status != 'sent' &&
                        item.status != 'approve' &&
                        (roleInfo == 'admin' || roleInfo == 'supervisor')
                      "
                      :disabled="
                        valuation.isLocked == true ||
                        valuation.status == 'cancel'
                      "
                    >
                      <i class="fa fa-check" aria-hidden="true"></i>
                    </button>

                    <button
                      type="button"
                      class="btn btn-icon btn-border"
                      title="Send"
                      @click="openSign(item)"
                      v-b-modal.send
                      v-if="
                        item.status == 'sign' &&
                        (roleInfo == 'admin' || roleInfo == 'supervisor')
                      "
                      :disabled="
                        valuation.isLocked == true ||
                        valuation.status == 'cancel'
                      "
                    >
                      <i class="fa fa-send" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="send"
      size="lg"
      title="Send Valuation"
      hide-footer
      ref="sendModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="sendValuation">
        <div class="row">
          <div class="col-md-12 error-container">
            <b-alert :show="isSignError" variant="danger">
              <ul class="error-list">
                <li v-for="(item, index) in signErrors" :key="index">
                  {{ item }}
                </li>
              </ul>
            </b-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Send Date</label>
              <datepicker
                input-class="form-control"
                format="dd/MM/yyyy"
                placeholder="dd/mm/yyyy"
                v-model="send.send_dt"
                calendar-button
                required
                calendar-button-icon="fa fa-calendar"
                bootstrap-styling
              ></datepicker>
              <!-- <input type="text" id="date1" class="form-control" name="example-text-input"> -->
            </div>
          </div>

          <div class="col-md-8">
            <div class="form-group">
              <label class="form-label">Receiver</label>
              <div class="input-group ig">
                <autocomplete
                  ref="assignedCustomer"
                  :source="customerEndPoint"
                  input-class="form-control"
                  results-property="data"
                  :results-display="formattedCustomerDisplay"
                  :request-headers="{
                    Authorization: 'Bearer ' + $parent.token,
                  }"
                  @selected="displayCustomerSelection"
                  @clear="clearCustomer"
                  @change.native="changeCustomer"
                ></autocomplete>
                <span class="input-group-append">
                  <button
                    class="btn"
                    type="button"
                    @click="addCustomer"
                    title="Add customer"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                  <button
                    :disabled="
                      typeof send.receiver_customer_id === 'undefined' ||
                      send.receiver_customer_id == '' ||
                      send.receiver_customer_id == null
                    "
                    class="btn"
                    type="button"
                    title="View customer"
                    @click="viewCustomer(send.receiver_customer_id)"
                  >
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Comments</label>
              <textarea
                class="form-control"
                v-model="send.comments"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Send Valuation
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeSendModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal
      id="sign"
      size="lg"
      title="Sign Valuation"
      hide-footer
      ref="signModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="signReport">
        <div class="row">
          <div class="col-md-12 error-container">
            <b-alert :show="isSignError" variant="danger">
              <ul class="error-list">
                <li v-for="(item, index) in signErrors" :key="index">
                  {{ item }}
                </li>
              </ul>
            </b-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">6-Digit PIN</label>
              <input
                type="password"
                class="form-control"
                @keypress="$parent.onlyNumber"
                required
                v-model="sign.key"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">
                Supervisor's Signature
                <button
                  title="Upload signature"
                  type="button"
                  class="btn btn-icon btn-icon-sm"
                  @click="manualSignature = !manualSignature"
                >
                  <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                </button>
              </label>
              <span v-if="manualSignature">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="form-label">File</label>
                      <div class="input-group">
                        <input
                          type="file"
                          id="signature-files"
                          class="form-control-file"
                          ref="signFile"
                          v-on:change="handleSignFile()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="isError">
                  <div class="col-md-12">
                    <div class="alert alert-danger" role="alert">
                      The file {{ error.name }} (Type: {{ error.type }}, Size:
                      {{ error.size }}MB) exceeds size limit of 25MB!
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <ul>
                      <li v-for="(file, key) in files" :key="key">
                        {{ file.name }}
                        <span class="success-container" v-if="file.id > 0"
                          >Success</span
                        >
                        <span class="remove-container" v-else>
                          <button
                            type="button"
                            class="btn btn-icon btn-sm"
                            v-on:click="removeFile(key)"
                          >
                            <i class="fa fa-times" aria-hidden="true"></i>
                          </button>
                        </span>
                        <br />
                        <img
                          class="preview"
                          style="max-height: 300px"
                          v-bind:ref="'preview' + parseInt(key)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 
                <div class="row" style="margin-bottom: 15px;">
                  <div class="col-md-12">
                    <button
                      type="button"
                      class="btn btn-primary pull-right"
                      v-on:click="submitManualFile()"
                    >Upload</button>
                    
                  </div>
                </div>-->
              </span>
              <VueSignaturePad
                v-if="!manualSignature"
                id="signature"
                width="100%"
                height="300px"
                ref="signaturePad"
                required
                :options="{ onBegin, onEnd }"
              />
              <!-- <textarea class="form-control" v-model="sign.signature" rows="4"></textarea> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Sign Valuation
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeSignModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="alert-draft"
      size="lg"
      title="Alert Team"
      hide-footer
      ref="alertModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="submitAlert">
        <div class="row">
          <div class="col-md-12 error-container">
            <b-alert :show="isSignError" variant="danger">
              <ul class="error-list">
                <li v-for="(item, index) in signErrors" :key="index">
                  {{ item }}
                </li>
              </ul>
            </b-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">To</label>
              <v-select
                required
                :options="users.data"
                label="email"
                taggable
                v-model="alert.to"
                multiple
              ></v-select>
              <!-- <input type="text" class="form-control" v-model="alert.to"> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Subject</label>
              <input
                type="text"
                class="form-control"
                required
                v-model="alert.subject"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">Message</label>
              <textarea
                class="form-control"
                required
                v-model="alert.message"
                rows="4"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Send
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeAlertModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal
      id="manual-report"
      size="lg"
      title="Upload Report"
      hide-footer
      ref="manualReport"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <span>
        <div class="row">
          <div class="col-md-12">
            <p>
              <strong>Note:</strong>
              Make sure you have replaced the signature with a placeholder
              <strong>${signature}</strong>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="form-label">File</label>
              <div class="input-group">
                <input
                  type="file"
                  id="manual-files"
                  class="form-control-file"
                  ref="manualFiles"
                  v-on:change="handleManualFile()"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="isError">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">
              The file {{ error.name }} (Type: {{ error.type }}, Size:
              {{ error.size }}MB) exceeds size limit of 25MB!
            </div>
          </div>
        </div>

        <div class="row" style="margin-bottom: 15px">
          <div class="col-md-12">
            <button
              type="button"
              class="btn btn-primary pull-right"
              v-on:click="submitManualFile()"
            >
              Upload
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeManualModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </span>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import Datepicker from "vuejs-datepicker";
import Wizard from "../components/Wizard";
import ValuationHeader from "../components/ValuationHeader";
import Autocomplete from "vuejs-auto-complete";
import Swal from "sweetalert2";
import vSelect from "vue-select";
import { eventBus } from "../main";
import { valuationMixin } from "../mixins/valuationMixin";
import { commonMixin } from "../mixins/commonMixin";

export default {
  mixins: [valuationMixin, commonMixin],

  components: {
    Datepicker,
    Autocomplete,
    "v-select": vSelect,
    "rv-wizard": Wizard,
    ValuationHeader,
  },

  data() {
    return {
      manualSignature: false,
      receiver_customer_id: "",
      send: {
        receiver_customer_id: "",
        send_dt: new Date(),
        comments: "",
      },
      alert: {
        to: "",
        subject: "",
        message: "",
      },
      upload: false,
      files: [],
      error: {},
      isError: false,
      uploads: [],
      note: "",
      template: "",
      isSignError: false,
      signErrors: [],
      valuation: {
        request_dt: "",
        due_dt: "",
        address: "",
        house_no: "",
        street_name: "",
        unit_no: "",
        project: "",
        postal_code: "",
        priority: "",
        supervisor_user_id: "",
        valuer_user_id: "",
        admin_user_id: "",
        bring_in_user_id: "",
        rm_customer_id: "",
        file_ref_num: "",
        requestor_customer_id: "",
        applicant_customer_id: "",
        lawyer_customer_id: "",
        pri_report_template_type: "",
        tenure_start_dt: "",
        tenure_type: "",
        other_tenure: "",
        property_type: "",
        top_dt: "",
        floor_level: "",
        storey_cnt: "",
        condition_type: "",
        orientation_type: "",
        occupancy_type: "",
        master_plan_zoning: "",
        city_centre_dist: "",
        omv: "",
        omv_sqf: "",
        firv: "",
        firv_sqf: "",
        fsv: "",
        fsv_sqf: "",
        purchase_price: "",
        purchase_price_sqf: "",
        legal_description: [],
        tenancy_details: [],
        revenue_category: "",
        filtered_report: [],
      },
      sign: {
        key: "",
        signature: "",
      },
      currentReport: {},
      users: {
        data: [],
      },
      customers: {
        data: [],
      },
      drawing: false,
      templateName: "",
      isSaved: false,
      templates: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    next();
  },

  computed: {
    userInfo() {
      return this.$store.getters.userInfo || {};
    },
    roleInfo() {
      return this.$store.getters.roleInfo || {};
    },
    isSigned: {
      get: function () {
        if (typeof this.$refs.signaturePad !== "undefined") {
          return !this.$refs.signaturePad.isEmpty();
        } else {
          return true;
        }
      },
      set: function (newVal) {},
    },
  },

  methods: {
    closeManualModal() {
      this.$refs.manualReport.hide();
    },
    closeAlertModal() {
      this.alert = {
        to: "",
        subject: "",
        message: "",
      };
      this.$refs.alertModal.hide();
    },
    closeSignModal() {
      this.sign = {
        key: "",
        signature: "",
      };
      this.$refs.signaturePad.clearSignature();
      this.$refs.signModal.hide();
    },
    closeSendModal() {
      this.send = {
        receiver_customer_id: "",
        send_dt: "",
        comments: "",
      };
      this.$refs.sendModal.hide();
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.isError = false;
      const input = this.$refs.signFile;
      input.type = "text";
      input.type = "file";
      this.getImagePreviews();
    },
    handleSignFile() {
      const uploadedFiles = this.$refs.signFile.files;

      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
      this.getImagePreviews();
    },
    clearCustomer() {
      this.send.receiver_customer_id = "";
    },
    changeCustomer($e) {
      if ($e.target.value == "") {
        this.clearCustomer();
      }
    },
    displayCustomerSelection(user) {
      this.send.receiver_customer_id = user.selectedObject.id;
    },
    manualReport(item) {
      this.templateName = item.name;
      this.$refs.manualReport.show();
    },
    submitManualFile() {
      if (typeof this.files[0] === "undefined") {
        return;
      }
      this.$refs.manualReport.hide();
      this.$parent.$refs.progressModal.show();
      const fileSize = this.files[0].size / 1024 / 1024;
      if (fileSize >= 25) {
        this.isError = true;
        this.error.size = fileSize.toFixed(2);
        this.error.name = this.files[0].name;
        this.error.type = this.files[0].type;
        this.loadData(this.valuation.id);
        return;
      }
      const formData = new FormData();
      formData.append("valuation_id", this.valuation.id);
      formData.append("template", this.templateName);
      formData.append("file", this.files[0]);

      return this.$http
        .post(this.rootUrl + "manual-report-upload", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(
          (res) => {
            this.refreshToken(res);
            this.$parent.$refs.progressModal.hide();
            this.files = [];
            this.isError = false;
            const input = this.$refs.manualFiles;
            if (typeof input !== "undefined") {
              input.type = "text";
              input.type = "file";
            }
            this.loadData(this.valuation.id);
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            this.$parent.$refs.progressModal.hide();
            this.$refs.manualReport.show();
          }
        );
    },

    handleManualFile() {
      const uploadedFiles = this.$refs.manualFiles.files;
      for (let i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i]);
      }
    },

    onBegin() {
      // signature
      let signaturePad = document.getElementById("signature");
      let cnv = signaturePad.children[0];
      if (this.drawing == false) {
        cnv.height = signaturePad.clientHeight;
        cnv.width = signaturePad.clientWidth;
        this.drawing = true;
      }
      this.isSigned = !this.$refs.signaturePad.isEmpty();
    },
    onEnd() {
      //
    },
    lockValuation() {
      let lockStatus;
      if (this.valuation.isLocked) {
        lockStatus = "unlock";
      } else {
        lockStatus = "lock";
      }
      Swal({
        title: "Are you sure to " + lockStatus + " valuation?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.$parent.$refs.progressModal.show();
          this.valuation.isLocked = !this.valuation.isLocked;
          this.$http
            .post(this.rootUrl + "valuation/summary", this.valuation)
            .then(
              (res) => {
                this.refreshToken(res);
                this.valuation = this.groupTemplate(res.data);
                this.$parent.$refs.progressModal.hide();
                Swal("Lock status updated", "", "success");
              },
              (err) => {
                this.$snotify.error(err.response.data.message, "Valuation", {
                  timeout: 4000,
                  showProgressBar: false,
                  position: "rightTop",
                });
                this.$parent.$refs.progressModal.hide();
              }
            );
        }
      });
    },
    viewCustomer(id) {
      const routeData = this.$router.resolve({
        path: "/view-customer/" + id,
        query: {
          mode: "view",
        },
      });
      window.open(routeData.href, "_blank");
    },

    async sendValuation() {
      if (this.send.send_dt === "") {
        return this.$snotify.error("A send date must be selected", null, {
          timeout: 4000,
          showProgressBar: false,
          position: "rightTop",
        });
      }

      this.$parent.$refs.progressModal.show();

      await this.$http
        .post(this.rootUrl + "send-report", {
          customer: this.send.receiver_customer_id,
          send_dt: this.send.send_dt,
          comments: this.send.comments,
          id: this.valuation.id,
          report: this.currentReport.id,
        })
        .then(
          (res) => {
            this.$snotify.success("Report sent", null, {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            this.refreshToken(res);
            this.$refs.sendModal.hide();
            this.valuation = this.groupTemplate(res.data);
            this.send = {
              receiver_customer_id: "",
              send_dt: "",
              comments: "",
            };
          },
          (err) => {
            this.$snotify.error(err.response.data.message, null, {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );

      this.$parent.$refs.progressModal.hide();
    },

    addCustomer() {
      this.$refs.sendModal.hide();
      this.$parent.$refs.addCustomerModal.show();
    },
    openSign(item) {
      this.currentReport = item;
      this.drawing = false;
    },

    async signReport() {
      let isEmpty, data;
      if (this.manualSignature == false) {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

        this.signErrors = [];
        if (
          isEmpty &&
          this.manualSignature == false &&
          this.files.length == 0
        ) {
          this.isSignError = true;
          this.signErrors.push("Signature required.");
        }
        if (this.sign.key == "") {
          this.isSignError = true;
          this.signErrors.push("Pass key required.");
        }

        if (this.signErrors.length == 0) {
          this.isSignError = false;
          this.$refs.signModal.hide();

          this.$parent.$refs.progressModal.show();

          await this.$http
            .post(this.rootUrl + "sign-report", {
              key: this.sign.key,
              isManual: this.manualSignature,
              signature: data,
              id: this.valuation.id,
              report: this.currentReport.id,
            })
            .then(
              (res) => {
                this.refreshToken(res);
                this.files = [];
                this.valuation = this.groupTemplate(res.data);
                this.sign = {
                  key: "",
                  signature: "",
                };

                if (typeof this.$refs.signaturePad !== "undefined") {
                  this.$refs.signaturePad.clearSignature();
                }

                this.$snotify.success("Report signed", null, {
                  timeout: 4000,
                  showProgressBar: false,
                  position: "rightTop",
                });
              },
              (err) => {
                this.$snotify.error(err.response.data.message, null, {
                  timeout: 4000,
                  showProgressBar: false,
                  position: "rightTop",
                });
                this.$parent.$refs.progressModal.hide();
              }
            );

          this.$parent.$refs.progressModal.hide();
        }
      } else {
        isEmpty = true;
        data = {};

        this.$refs.signModal.hide();

        this.$parent.$refs.progressModal.show();

        const fileSize = this.files[0].size / 1024 / 1024;
        if (fileSize >= 25) {
          this.isError = true;
          this.error.size = fileSize.toFixed(2);
          this.error.name = this.files[0].name;
          this.error.type = this.files[0].type;
          return;
        }
        const formData = new FormData();
        formData.append("file", this.files[0]);
        await this.$http
          .post(this.rootUrl + "file/empty-upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(
            (res) => {
              this.refreshToken(res);
              let url = res.data;
              this.signErrors = [];
              if (this.files.length == 0) {
                this.isSignError = true;
                this.signErrors.push("Signature required.");
              }
              if (this.sign.key == "") {
                this.isSignError = true;
                this.signErrors.push("Pass key required.");
              }

              if (this.signErrors.length == 0) {
                this.isSignError = false;

                return this.$http
                  .post(this.rootUrl + "sign-report", {
                    key: this.sign.key,
                    isManual: this.manualSignature,
                    signature_url: url,
                    id: this.valuation.id,
                    report: this.currentReport.id,
                  })
                  .then(
                    (res) => {
                      this.refreshToken(res);
                      this.files = [];
                      this.valuation = this.groupTemplate(res.data);
                      this.sign = {
                        key: "",
                        signature: "",
                      };

                      this.manualSignature = false;
                      this.$snotify.success("Report signed", "Valuation", {
                        timeout: 4000,
                        showProgressBar: false,
                        position: "rightTop",
                      });
                    },
                    (err) => {
                      this.$snotify.error(
                        "Invalid pass key or some error occured",
                        "Valuation",
                        {
                          timeout: 4000,
                          showProgressBar: false,
                          position: "rightTop",
                        }
                      );
                    }
                  );
              }
            },
            (err) => {
              this.$snotify.error(err.response.data.message, null, {
                timeout: 4000,
                showProgressBar: false,
                position: "rightTop",
              });
              this.$refs.signModal.show();
            }
          );
        this.$parent.$refs.progressModal.hide();
      }
    },
    submitAlert() {
      this.signErrors = [];
      if (this.alert.to == "") {
        this.isSignError = true;
        this.signErrors.push("To field required");
      }

      if (this.signErrors.length == 0) {
        this.isSignError = false;
        this.$parent.$refs.progressModal.show();
        this.$http
          .post(this.rootUrl + "alert", {
            id: this.currentReport.id,
            to: this.alert.to,
            subject: this.alert.subject,
            message: this.alert.message,
          })
          .then(
            (res) => {
              this.$snotify.success("Sent alert.", "Valuation", {
                timeout: 4000,
                showProgressBar: false,
                position: "rightTop",
              });
              this.refreshToken(res);
              this.$refs.alertModal.hide();
              this.alert = {
                to: "",
                subject: "",
                message: "",
              };
              this.$parent.$refs.progressModal.hide();
            },
            (err) => {
              this.$snotify.error(err.response.data.message, "Valuation", {
                timeout: 4000,
                showProgressBar: false,
                position: "rightTop",
              });
              this.$parent.$refs.progressModal.hide();
            }
          );
      }
    },
    openAlert(item) {
      this.currentReport = item;
      //this.alert.to = "";
      if (this.valuation.supervisor != null) {
        //this.alert.to += this.valuation.supervisor.email;
      }
      if (this.valuation.supervisor != null && this.valuation.admin != null) {
        //this.alert.to += ",";
      }
      if (this.valuation.admin != null) {
        //this.alert.to += this.valuation.admin.email;
      }

      this.alert.subject = "Valuation " + this.valuation.val_ref_num;
      this.alert.message = "Report is ready for sending.";
    },

    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          const reader = new FileReader();
          reader.addEventListener(
            "load",
            function () {
              this.$refs["preview" + parseInt(i, 10)][0].src = reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function () {
            this.$refs["preview" + parseInt(i, 10)][0].src = "/img/generic.png";
          });
        }
      }
    },

    // submitFiles() {
    //   for (let i = 0; i < this.files.length; i++) {
    //     this.$refs.fileDumpModal.hide();
    //     this.$parent.$refs.progressModal.show();
    //     const fileSize = this.files[i].size / 1024 / 1024;
    //     if (fileSize >= 25) {
    //       this.isError = true;
    //       this.error.size = fileSize.toFixed(2);
    //       this.error.name = this.files[i].name;
    //       this.error.type = this.files[i].type;
    //       this.loadData(this.valuation.id);
    //       return;
    //     }
    //     const formData = new FormData();
    //     formData.append("file", this.files[i]);
    //     formData.append("valuation_id", this.valuation.id);
    //     this.$http
    //       .post(this.rootUrl + "valuation-file-upload", formData, {
    //         headers: {
    //           "Content-Type": "multipart/form-data"
    //         }
    //       })
    //       .then(
    //         function(res) {
    //           this.refreshToken(res);
    //           this.loadData(this.valuation.id);
    //           this.upload = false;
    //           this.$parent.$refs.progressModal.hide();
    //           this.$refs.fileDumpModal.show();
    //         }.bind(this)
    //       )
    //       .catch(err => {
    //         this.$snotify.error(err.response.data.message, "Valuation", {
    //           timeout: 4000,
    //           showProgressBar: false,
    //           position: "rightTop"
    //         });
    //         this.$parent.$refs.progressModal.hide();
    //         this.$refs.fileDumpModal.show();
    //       });
    //   }

    //   this.resetFile();
    //   //this.$refs.fileUploadModal.hide();
    // },
    // resetFile() {
    //   this.files = [];
    //   this.isError = false;
    //   const input = this.$refs.files;
    //   input.type = "text";
    //   input.type = "file";
    // },

    async generateReport() {
      this.$parent.$refs.progressModal.show();
      await this.$http
        .post(this.rootUrl + "valuation/drafts", {
          id: this.valuation.id,
          template: this.template,
          current_user_role: sessionStorage.getItem("role"),
        })
        .then(
          (res) => {
            this.refreshToken(res);
            if (typeof res.data != "undefined" && res.data.isError == true) {
              this.errorToast(res.data.message);
            }
            this.valuation = this.groupTemplate(res.data);
          },
          (err) => {
            this.$snotify.error(err.response.data.message, null, {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );

      this.$parent.$refs.progressModal.hide();
    },

    navigateTo(page) {
      this.$router.push({
        name: page,
        params: {
          id: this.$route.params.id,
        },
      });
    },

    loadData(id) {
      //this.$parent.$refs.progressModal.show();
      return this.$http
        .get(this.rootUrl + "valuation/" + id, this.corsConfig)
        .then(
          (res) => {
            this.refreshToken(res);
            this.valuation = this.groupTemplate(res.data);
            this.template = this.valuation.pri_report_template_type;
            //this.$parent.$refs.progressModal.hide();
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
            //this.$parent.$refs.progressModal.hide();
          }
        );
    },

    getUsers() {
      //this.$parent.$refs.progressModal.show();
      return this.$http.get(this.rootUrl + "user", this.corsConfig).then(
        (res) => {
          this.refreshToken(res);
          this.users = res.data;
          //this.$parent.$refs.progressModal.hide();
        },
        (err) => {
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
          //this.$parent.$refs.progressModal.hide();
        }
      );
    },

    getCustomers() {
      //this.$parent.$refs.progressModal.show();
      return this.$http.get(this.rootUrl + "customer", this.corsConfig).then(
        (res) => {
          this.refreshToken(res);
          this.customers = res.data;
          //this.$parent.$refs.progressModal.hide();
        },
        (err) => {
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
          //this.$parent.$refs.progressModal.hide();
        }
      );
    },

    groupTemplate(data) {
      if (typeof data.reports !== "undefined" && data.reports != null) {
        let templates = _.uniq(
          _.compact(_.map(data.reports, "report_template_type"))
        );
        data.filtered_report = [];
        templates.forEach(function (item) {
          let obj = { name: item };
          obj.reports = _.map(data.reports, function (o) {
            if (o.report_template_type === item) return o;
          });
          if (obj != null) {
            data.filtered_report.push(obj);
          }
        });
      }
      return data;
    },
  },

  async mounted() {
    this.$parent.$refs.progressModal.show();

    let iterates = [this.loadTemplates()];

    if (typeof this.$route.params.id !== "undefined") {
      iterates.push(this.loadData(this.$route.params.id));
      iterates.push(this.getUsers());
      iterates.push(this.getCustomers());

      await Promise.all(iterates);
    } else {
      await Promise.all(iterates);

      this.$router.push("valuations");
    }

    this.$parent.$refs.progressModal.hide();

    eventBus.$on("customerUpdated", (data) => {
      if (data.customer != null) {
        this.send.receiver_customer_id = data.customer.id;
        this.receiver_customer_id =
          data.customer.name + " (" + data.customer.cust_ref_num + ")";
        this.$refs.assignedCustomer.$el.children[0].children[1].children[0].value =
          this.receiver_customer_id;
      }

      this.$refs.sendModal.show();
    });
  },
};
</script>
